// Company legal & contact info (single source of truth)
export const COMPANY = {
  brand: "HO-SYS",
  legalName: "Hosys Advanced Digital Technologies SLU",
  cif: "B88719794",
  registry: "Registre Mercantil, Full T-00066453",
  irus: "1000474955269",
  email: "info@hosys.es",
  phone: "+34696990879",
  phoneDisplay: "696 99 08 79",
  whatsapp: "https://wa.me/34696990879",
  calendar: "https://calendly.com/hosys/demo",
  city: "Reus, Catalunya",
  linkedin: "https://www.linkedin.com",
};
